import React, { useEffect } from "react";
import queryString from 'query-string';
import Parser from 'html-react-parser';

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formateDate, transformValueFloattoFormated } from "../../helpers/formats";

// components
import LogoSistema from "../../components/LogoSistema/LogoSistema";

//Context
import { useAuth } from "../../context/auth";

export default function CertificadoTransportador({ history }) {
    const { setLoading, setupSistema } = useAuth();

    var QRCode = require('qrcode.react');

    const [dadoscarteirinha, set_dadoscarteirinha] = React.useState(null);
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        setLoading(true);
        api_GET('protocolotransportador/GetCertificadoTransportador/' + params.protocolo)
            .then(result => {
                if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                    if (result.data.status == "Inativo") {
                        showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                        return;
                    } else {
                        showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                        return;
                    }
                }
                set_dadoscarteirinha(result.data);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {dadoscarteirinha &&
                <div style={{ width: "100%", height: "29.7cm", marginTop: "2cm" }}>
                    <div className="row">
                        <div className="col-2">
                            <LogoSistema identificacaoLogo={"logotipo"} width='150' style={{marginTop:"10px"}} />
                        </div>
                        <div className="col-8 text-center">
                            {Parser(dadoscarteirinha.cabecalho)}
                        </div>
                        <div className="col-2"></div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <h4><b>CERTIFICADO DE CREDENCIAMENTO PARA TRANSPORTE DE RESÍDUOS</b></h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p><b>Protocolo: {dadoscarteirinha.protocolo}</b></p>
                            <p><b>Validade: {formateDate(dadoscarteirinha.validadeCadastro)}</b></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-justify">
                            {Parser(dadoscarteirinha.legislacao)}
                            <p><b>CNPJ: {dadoscarteirinha.cnpj}</b></p>
                            <p><b>Razão Social: {dadoscarteirinha.razaoSocial}</b></p>
                            <p><b>Endereço: {dadoscarteirinha.enderecoCompleto}</b></p>
                            <p>Os veículos credenciados (citados na tabela "Quadro Demonstrativo da Frota" deste certificado) deverão ser de uso exclusivo dos serviços de coleta e transporte de resíduos requeridos, sendo vedada a sua utilização para outras modalidades.</p>
                            <p>Este certificado de credenciamento tem validade até {formateDate(dadoscarteirinha.validadeCadastro)}, e sua renovação dependerá de requerimento do interessado, desde que haja o cumprimento das exigências conferidas na legislação municipal, estadual e federal acerca do tema.</p>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <QRCode value={setupSistema?.urL_WEB_ROC + "/empty/CertificadoTransportador?protocolo=" + dadoscarteirinha.protocolo} />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <h4>Quadro Demonstrativo da Frota</h4>
                        </div>
                        <div className="col-12 text-center">
                            <table border="1">
                                <thead>
                                    <tr>
                                        <th>Placa</th>
                                        <th>Próprio ou Locado</th>
                                        <th>Marca e Modelo do Chassi</th>
                                        <th>Ano de Fab. do Chassi</th>
                                        <th>Cap. de Carga (KG)</th>
                                        <th>Tara (KG)</th>
                                        <th>Tipo de Equipamento</th>
                                        <th>Ano de Fab. do Equip.</th>
                                        <th>Cor</th>
                                        <th>Volume (m³)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadoscarteirinha.veiculos.map((m, key) => {
                                        return <tr key={key}>
                                            <td>{m.placa}</td>
                                            <td>{m.proprioOuLocado}</td>
                                            <td>{m.marcaModelo}</td>
                                            <td>{m.anoFabricacao}</td>
                                            <td>{m.capacidadeCarga}</td>
                                            <td>{m.tara}</td>
                                            <td>{m.tipoEquipamento}</td>
                                            <td>{m.anoFabricacaoEquipamento}</td>
                                            <td>{m.cor}</td>
                                            <td>{transformValueFloattoFormated(m.volume)}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br /><br /><br /><br />
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <LogoSistema identificacaoLogo={"logotipo"} width='150' />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}